import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f0255ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }, " お届け先 ", -1))
const _hoisted_2 = { class: "ncgr-mar-t-24" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }, " お支払い方法 ", -1))
const _hoisted_4 = { class: "ncgr-mar-t-24" }
const _hoisted_5 = { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }
const _hoisted_6 = { class: "ncgr-mar-t-24 ncgr-mar-b-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShippingAddressConfirm = _resolveComponent("ShippingAddressConfirm")!
  const _component_PaymentConfirm = _resolveComponent("PaymentConfirm")!
  const _component_ProductConfirm = _resolveComponent("ProductConfirm")!
  const _component_PriceConfirm = _resolveComponent("PriceConfirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createVNode(_component_ShippingAddressConfirm, { address: _ctx.shippingAddress }, null, 8, ["address"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_PaymentConfirm, {
        payment: _ctx.payment,
        useRegisteredCreditCard: _ctx.useRegisteredCreditCard
      }, null, 8, ["payment", "useRegisteredCreditCard"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.campaign.name) + " " + _toDisplayString(_ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)), 1),
      _createVNode(_component_ProductConfirm, {
        campaign: _ctx.campaign,
        selections: _ctx.selections
      }, null, 8, ["campaign", "selections"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_PriceConfirm, {
        campaign: _ctx.campaign,
        selections: _ctx.selections,
        payment: _ctx.payment
      }, null, 8, ["campaign", "selections", "payment"])
    ])
  ]))
}